// Put your applicaiton javascript here

var promo1 = 0;
var promo2 = 0;
var banner1 = 0;
var banner2 = 0;
var mainBanner = 0;

function hidepromo1Popup() {
  document.getElementById('promo1').style.display = 'none';
}

function hidepromo2Popup() {
  document.getElementById('promo2').style.display = 'none';
}

function getStatusAndBannerImage() {
  var fetchUrl = "https://cfllc-shopify.charliesfixtures.com/getStatusAndBannerImage";
  var shopPassUrl= "https://" + window.location.hostname +"/password"; 
  
  //check if first visit
  var prev_url = document.referrer;
  var firstvisit = true;
  
  if(prev_url){
    if(prev_url != shopPassUrl){
      if(prev_url.includes(window.location.hostname)){
        firstvisit = false;
      }
    }
  }
  
  if(event.currentTarget.performance.navigation.type == 1){
    firstvisit = true;
  }

  fetch(fetchUrl)
  .then(response => response.json())
  .then(data => {
    // set banner images
    if(data.data.banners && data.data.banners.length){
      data.data.banners.forEach(element => {
        if(element.name == "mainBanner"){
          document.getElementById("mainBanner").src = "https://cdn.shopify.com/s/files/1/0003/3082/5764/files/1712918639.webp?v=1753414746";
          mainBanner = element.status;
        }
        if(element.name == "promo1"){
          document.getElementById("promo1Banner").src = element.image;
          banner1 = element.status;
          
        }
        if(element.name == "promo2"){
          document.getElementById("promo2Banner").src = element.image;
          banner2 = element.status;
        }
      })
    }
    //check promo status
      if(data.data.serviceStatus && data.data.serviceStatus.length){
      data.data.serviceStatus.forEach(element => {
        if(element.name == "Subsequent_Order"){
          promo2 = element.status;
        }
        if(element.name == "First_Order"){
          promo1 = element.status;
        }
        if(mainBanner == 1 && firstvisit){          
            document.getElementById('freePopupModal').style.display = 'block';
        }
        if(banner2 == 1){             
            document.getElementById('promo2').style.display = 'block';
            $('#promo2').delay(3000).hide(0);            
        }
        if (banner1 == 1){
            document.getElementById('promo1').style.display = 'block';
            $('#promo1').delay(3000).hide(0);             
            }    
          })
        } 
    
  })
    .catch(function(error) {
      console.log(error);
  });  

}

function hideOnvisitPopup() {
  document.getElementById('freePopupModal').style.display = 'none';
  document.body.style.position = 'unset';
  if(promo2 == 1 && banner2 == 1){
	document.getElementById('promo2').style.display = 'block';
    $('#promo2').delay(3000).hide(0); 
  }
  if(promo1 == 1 && banner1 == 1){
	document.getElementById('promo1').style.display = 'block';
    $('#promo1').delay(3000).hide(0);
  }
   
}
